import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  accordion: {
    '&:before': {
      display: 'none',
    },

    '&.MuiAccordion-root': {
      borderRadius: theme.new.shape.borderRadius.small,
      marginBlockEnd: '20px',
      boxShadow: 'none',
      backgroundColor: theme.new.color.background.page,
      padding: '0px',
    },

    '&.Mui-expanded': {
      margin: '0px',
    },

    '& .MuiAccordionSummary-root': {
      minHeight: 'unset',
      padding: theme.new.spacing.small,

      '&.Mui-expanded': {
        minHeight: 'unset',
      },
    },

    '& .MuiAccordionSummary-contentGutters': {
      margin: '0px',

      '&.Mui-expanded': {
        margin: '0px',
      },
    },

    '& .MuiAccordionDetails-root': {
      padding: theme.new.spacing.small,
    },
  },

  container: {
    backgroundColor: theme.new.color.common.white,
    borderRadius: theme.new.shape.borderRadius.small,
    padding: theme.new.spacing.medium,
  },

  previewSection: {
    width: '100%',
  },

  previewRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '12px',
    borderRadius: theme.new.shape.borderRadius.small,
    backgroundColor: theme.new.color.common.white,

    '& svg > path': {
      stroke: theme.new.color.brandPrimary,
    },
  },

  previewItemContainer: {
    position: 'relative',
  },

  previewThumb: {
    width: '78px',
    height: '78px',
    flexShrink: 0,
    borderRadius: theme.new.shape.borderRadius.small,
    border: `1px solid ${theme.new.color.grey[400]}`,
    overflow: 'hidden',
  },

  previewImg: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  removeButton: {
    position: 'absolute',
    top: '-4px',
    right: '-4px',
    width: 12,
    height: 12,
    padding: 0,
    border: 'none',
    cursor: 'pointer',
    borderRadius: '50%',
    color: theme.new.color.common.white,
    backgroundColor: theme.new.color.grey[600],

    '& svg > g > path': {
      stroke: theme.new.color.common.white,
    },
  },

  removeIcon: {
    width: '12px',
    height: '12px',
  },

  dragAndDrop: {
    boxSizing: 'border-box',
    width: '78px',
    height: '78px',
    padding: theme.new.spacing.xsmall,
    borderRadius: theme.new.shape.borderRadius.small,
    backgroundColor: theme.new.color.brand[100],
    cursor: 'pointer',
  },

  uploadSection: {
    cursor: 'pointer',
  },

  imageUploadIcon: {
    marginBlockEnd: theme.new.spacing.xsmall,
  },

  sizeErrorRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: theme.new.spacing.xsmall,
    marginTop: theme.new.spacing.small,
  },

  sizeErrorIcon: {
    '& rect, & path': {
      stroke: theme.new.color.errorPrimary,
    },
  },

  sizeErrorText: {
    color: theme.new.color.errorPrimary,
  },
}));

export default useStyles;
